module.exports = __webpack_public_path__ + "img/michael_sum_lepfefqf_pDe2N.009c683b.jpg";